import React from 'react';
import './ScoreBar.css';

const ScoreBar = ({ score = 66 }) => {
  // Calculate how many boxes should be filled based on the score percentage
  const totalBoxes = 20;
  const filledBoxes = Math.round((score / 100) * totalBoxes);
  
  // Determine color class based on score
  let colorClass = 'green'; // Default for scores above 75%
  if (score < 50) {
    colorClass = 'red';
  } else if (score >= 50 && score <= 75) {
    colorClass = 'yellow';
  }

  return (
      <div className="scrbr-progress-boxes">
        {Array.from({ length: totalBoxes }).map((_, index) => (
          <div 
            key={index} 
            className={`scrbr-box ${index < filledBoxes ? `scrbr-filled scrbr-${colorClass}` : ''}`}
          />
        ))}
      </div>
  );
};

export default ScoreBar;